/**
 * Reseller-admin layout route (CLA-904).
 *
 * The reseller-admin screens render their OWN shell (the design `AdminShell`:
 * rail + "Partner operations" topbar), so mounting them inside the zinc
 * `/clawinstall/admin` layout's `<Outlet />` would double the chrome. This route
 * lives under `admin_/resellers/` — TanStack's trailing-underscore escape keeps
 * the `/clawinstall/admin/resellers…` URLs while opting OUT of that layout — and
 * re-applies the SAME admin gate here so a non-admin who reaches these URLs is
 * bounced rather than shown the console.
 *
 * The `beforeLoad` guard runs server-side (it constructs an RPC client and reads
 * the request cookie); the layout component and its imports are deferred to
 * `route.lazy.tsx` so they never land in the always-loaded `main` chunk.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import { requireAdmin } from "~/lib/server-admin.ts";

export const Route = createFileRoute("/clawinstall/admin_/resellers")({
  // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await
  beforeLoad: async () => {
    // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await
    const auth = await requireAdmin();
    return { auth };
  },
});
